import request from "@/utils/request";
import URL from "@/api/baseUrl";

export default class VipOceanOrder {
  static list(params = {}, config = {}) {
    return request.get(`${URL.vip}/vip-ocean-order/list`, params, config);
  }

  static detail(id) {
    return request.get(`${URL.vip}/vip-ocean-order/${id}`);
  }

  static statusCount(params = {}) {
    return request.get(`${URL.vip}/vip-ocean-order/statusCount`, params);
  }

  static haipaiDeliveryParcelList(data = {}) {
    return request.post(`${URL.vip}/vip-ocean-order/haipaiDeliveryParcelList`, data);
  }

  static haipaiDeliveryTrackingEventList(data = {}) {
    return request.post(`${URL.vip}/vip-ocean-order/haipaiDeliveryTrackingEventList`, data);
  }

  static export(data = {}) {
    return request.post(`${URL.vip}/vip-ocean-order/export`, data, {
      responseType: "blob",
    });
  }

  static excelOrderMarkList(data = {}) {
    return request.post(`${URL.vip}/vip-ocean-order/excelOrderMarkList`, data, {
      responseType: "blob",
    });
  }

  static excelOrderMarkA4List(data = {}) {
    return request.post(`${URL.vip}/vip-ocean-order/excelOrderMarkA4List`, data, {
      responseType: "blob",
    });
  }

  static excelOrderReceipt(data = {}) {
    return request.post(`${URL.vip}/vip-ocean-order/excelOrderReceipt`, data, {
      responseType: "blob",
    });
  }

  static inWarehouseDataPrint(data = {}) {
    return request.post(`${URL.vip}/vip-ocean-order/inWarehouseDataPrint`, data, {
      responseType: "blob",
    });
  }

  static downloadScanningImage(data = {}) {
    return request.post(`${URL.vip}/vip-file/downloadScanningImage`, data, {
      responseType: "blob",
    });
  }

  static downloadPod(data = {}) {
    return request.post(`${URL.vip}/vip-file/downloadPod`, data, {
      responseType: "blob",
    });
  }

  static traceExport(data = {}) {
    return request.post(`${URL.vip}/vip-file/traceExport`, data, {
      responseType: "blob",
    });
  }
}
